import store from '@/states/index.js'

import FormRequest from '../FormComponent'

export default [
    {
        path: '/form_request_s',
        component: FormRequest,
        name: '/form_request_s',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 2){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]